import React from 'react';
import { Row, Col } from 'react-bootstrap5';
import * as Yup from 'yup';
import { Formik, Form as FormikForm } from 'formik';

import Footer from 'components/Widgets/Profile/FormFooter';
import HorizontalFileField from 'components/new_ui/Form/HorizontalFileField';
import HorizontalTextField from 'components/new_ui/Form/HorizontalTextField';
import { useContext as useUsersContext } from 'components/Users/Context';
import Actions from 'components/Members/Profile/Actions';
import Modal from 'components/new_ui/Modal/Modal';

import { useNavigate } from 'react-router-dom';

export default function General() {
  const { dispatch: dispatchUsers, actions: actionsUsers, state: stateUsers } = useUsersContext();

  const navigate = useNavigate();

  const member = stateUsers.user.attributes.specific;

  const formSchema = Yup.object().shape({
    first_name: Yup.string().required('First Name is required'),
    last_name: Yup.string().required('Last Name is required'),
  });

  const onSubmitHundler = (values, { setSubmitting, setErrors }) => {
    Actions.update(
      member.id,
      values,
      true,
      () => {
        setSubmitting(false);
        actionsUsers.load(dispatchUsers);
        navigate(-1);
      },
      (errors) => {
        const newErrors = {};
        errors.errors.forEach((item) => {
          newErrors[item.source.pointer.replace('/data/attributes/', '')] = item.detail;
        });
        setErrors(newErrors);
        setSubmitting(false);
      },
    );
  };

  return (
    <Modal size="lg" show>
      <Formik
        validationSchema={formSchema}
        initialValues={{
          first_name: member.first_name,
          last_name: member.last_name,
          company_position: member.company_position,
          avatar: member.avatar_present ? member.avatar_url : null,
        }}
        onSubmit={onSubmitHundler}
      >
        {({ isSubmitting }) => (
          <FormikForm className="needs-validation" noValidate="">
            <Row>
              <Col lg={6}>
                <HorizontalFileField
                  name="avatar"
                  useCrop
                />
              </Col>

              <Col lg={6}>
                <HorizontalTextField name="first_name" label="First Name" required />

                <HorizontalTextField name="last_name" label="Last Name" required />
              </Col>
            </Row>

            <Row>
              <Col>
                <HorizontalTextField name="company_position" label="Position" />
              </Col>
            </Row>

            <Footer loading={isSubmitting} onCancel={() => navigate(-1)} />
          </FormikForm>
        )}
      </Formik>
    </Modal>
  );
}
